import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from './utils/AuthContext.js'; // 경로는 실제 구조에 맞게 조정
import { PrivateRoute } from './routes/PrivateRoute.js'

import Index from './pages/user/Index';
import Sub1_1 from './pages/user/Sub1_1';
import Sub1_2 from './pages/user/Sub1_2';
import Sub1_3 from './pages/user/Sub1_3';

import Sub2_1_1 from './pages/user/Sub2_1_1';
import Sub2_1_2 from './pages/user/Sub2_1_2';
import Sub2_1_3 from './pages/user/Sub2_1_3';
import Sub2_1_4 from './pages/user/Sub2_1_4';
import Sub2_1_5 from './pages/user/Sub2_1_5';
import Sub2_1_7 from './pages/user/Sub2_1_7';

import Sub2_2 from './pages/user/Sub2_2';

import Sub2_3_1 from './pages/user/Sub2_3_1';
import Sub2_3_2 from './pages/user/Sub2_3_2';

import Sub2_4 from './pages/user/Sub2_4';
import Sub2_5 from './pages/user/Sub2_5';

import Sub3_1 from './pages/user/Sub3_1'
import Sub3_2 from './pages/user/Sub3_2'

import Sub4_1 from './pages/user/Sub4_1'
import Sub4_2 from './pages/user/Sub4_2'
import Sub4_3 from './pages/user/Sub4_3'

import Sub5_1 from './pages/user/Sub5_1'

import Sub6_1 from './pages/user/Sub6_1'
import Sub6_2 from './pages/user/Sub6_2'

import Admin from './pages/admin/Admin'; 
import UpdatePassword from './pages/admin/UpdatePassword';

import Event from './pages/admin/Event'
import EventDetail from './pages/admin/EventDetail'
import EventWrite from './pages/admin/EventWrite'

import Review from './pages/admin/Review'
import ReviewDetail from './pages/admin/ReviewDetail'
import ReviewWrite from './pages/admin/ReviewWrite'

import Contact from './pages/admin/Contact'
import ContactDetail from './pages/admin/ContactDetail'
import Service from './pages/admin/Service'

import Faq from './pages/admin/Faq'
import FaqDetail from './pages/admin/FaqDetail'
import FaqWrite from './pages/admin/FaqWrite'

import Popup from './pages/admin/Popup'

import FixIcon from './components/user/common/FixIcon.jsx';

function ConditionalFixIcon() {
  const location = useLocation();
  
  // /admin으로 시작하는 경로에서는 FixIcon을 렌더링하지 않음
  if (location.pathname.startsWith('/admin')) {
    return null;
  }
  
  return <FixIcon />;
}

function App() {
  return (
    <>
      <BrowserRouter basename='/'>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Index />} />

            <Route path="/sub1_1" element={<Sub1_1 />} />
            <Route path="/sub1_2" element={<Sub1_2 />} />
            <Route path="/sub1_3" element={<Sub1_3 />} />

            <Route path="/sub2_1_1" element={<Sub2_1_1 />} />
            <Route path="/sub2_1_2" element={<Sub2_1_2 />} />
            <Route path="/sub2_1_3" element={<Sub2_1_3 />} />
            <Route path="/sub2_1_4" element={<Sub2_1_4 />} />
            <Route path="/sub2_1_5" element={<Sub2_1_5 />} />
            <Route path="/sub2_1_7" element={<Sub2_1_7 />} />

            <Route path="/sub2_2" element={<Sub2_2 />} />

             <Route path="/sub2_3_1" element={<Sub2_3_1 />} />
              <Route path="/sub2_3_2" element={<Sub2_3_2 />} />

            <Route path="/sub2_4" element={<Sub2_4 />} />
            <Route path="/sub2_5" element={<Sub2_5 />} />

            <Route path="/sub3_1" element={<Sub3_1 />} />
            <Route path="/sub3_2" element={<Sub3_2 />} />

            <Route path="/sub4_1" element={<Sub4_1 />} />
            <Route path="/sub4_2" element={<Sub4_2 />} />
            <Route path="/sub4_3" element={<Sub4_3 />} />

            <Route path="/sub5_1" element={<Sub5_1 />} />

            <Route path="/sub6_1" element={<Sub6_1 />} /> 
            <Route path="/sub6_2" element={<Sub6_2 />} />

            <Route path="/admin" element={<Admin />} />
             <Route path="/admin/updatePassword" element={<UpdatePassword />} />

            <Route path="/admin/event" element={<Event />} />
            <Route path="/admin/event_d/:id" element={<EventDetail />} />
            <Route path="/admin/event_w" element={<EventWrite />} />
            <Route path="/admin/review" element={<Review />} />
            <Route path="/admin/review_d/:id" element={<ReviewDetail />} />
            <Route path="/admin/review_w" element={<ReviewWrite />} />
            <Route path="/admin/contact" element={<Contact />} />
            <Route path="/admin/contact_d/:id" element={<ContactDetail />} />
            <Route path="/admin/service" element={<Service />} />

            <Route path="/admin/faq" element={<Faq />} />
            <Route path="/admin/faq_d/:id" element={<FaqDetail />} />
            <Route path="/admin/faq_w" element={<FaqWrite />} />

                <Route path="/admin/popup" element={<Popup />} />
          </Routes>
          
          <ConditionalFixIcon />
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default App;